<app-pagetoolbar icon="group" label="Pair History"> </app-pagetoolbar>
<div class="participant-boxes separator-bottom responsive-layout">
  <app-participant-box [history]="true" [donor]="pair?.donor" [pair]="pair" style="flex: 1; border-right: 1px solid #eee"></app-participant-box>
  <app-participant-box [history]="true" [recipient]="pair?.recipient" [pair]="pair" style="flex: 1"></app-participant-box>
</div>
<app-participant-history-box [timelineHistory]="timelineHistoryPair"></app-participant-history-box>
